/**
 * Single source of truth for brand-related defaults and the primary-goal
 * options, shared by the Brand Brief editor and the New Project wizard.
 */

// Fallback brand color before the owner picks one. Amber-500 = Markaii's own
// primary, so an unset project reads as "brand color not chosen yet" rather
// than a random blue.
export const DEFAULT_BRAND_COLOR = '#f59e0b';

export const GOAL_OPTIONS = [
  { value: '',           label: 'Not set — let the AI balance' },
  { value: 'awareness',  label: 'Awareness / reach' },
  { value: 'followers',  label: 'Follower growth' },
  { value: 'leads',      label: 'Leads (DMs / profile visits)' },
  { value: 'sales',      label: 'Sales / signups' },
  { value: 'engagement', label: 'Engagement (comments / saves)' },
];

export const GOAL_LABEL = Object.fromEntries(GOAL_OPTIONS.map((g) => [g.value, g.label]));
